import { useTranslation } from "react-i18next";
import { PassengerSelectionTile } from "../components";
import { useSSRContext } from "../../../context/SSRContext";

export default function PassengerSelectionWeb() {
  const { t } = useTranslation();
  const { cursor, passengerOptions, handleChange } = useSSRContext();

  return (
    <div className="flex flex-col gap-4 px-2">
      <div className="text-lg font-semibold">{t("Flights.details.ssr.whosChoosing")}</div>
      <div className="flex flex-col gap-2">
        {passengerOptions.map((passenger) => {
          const isActive = passenger.value === cursor.passengerId;
          return (
            <div onClick={handleChange("passengerId", passenger.value)} key={passenger.value}>
              <PassengerSelectionTile passenger={passenger} isActive={isActive} />
            </div>
          );
        })}
      </div>
    </div>
  );
}
